import { FC } from "react";
import { BenefitSummaryType } from "./types";


const DetailPageInfo: FC<BenefitSummaryType> = ({ benefit_summary, coverage_summary, caseObject, isCasePage, drug_name, isPatient }): JSX.Element => {
const pharmacy = coverage_summary?.qutenza_pharmacy;
const denialSummary = coverage_summary?.denial_summary;

const showPaDates = pharmacy?.primary_pa_req === "Y";
const showDenial = denialSummary?.denial === "Y";
const showAppeal = denialSummary?.appeal === "Y";
const showAppealDenial =
  showAppeal && denialSummary?.appeal_outcome === "Denied";

const primaryColumns =
  3 +
  (showPaDates ? 2 : 0) +
  (showDenial ? 2 : 0) +
  (showAppeal ? 2 : 0) +
  (showAppealDenial ? 2 : 0);


    return (
        <div className="card rounded-1">
            <div className={`card-header ${isPatient ? "" : drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <h4 className={`mb-0 ${isCasePage ? `` : `text-black`}`}>
                        {isCasePage ? "Benefits Summary" : "Most Recent Benefits Information"}
                    </h4>
                </div>
            </div>

            <div className="card-body">
                {!isCasePage && (
                    <p>Note: Please download the Benefits Investigations results forms for full details</p>
                )}

                {benefit_summary !== null && coverage_summary !== null ?
                    <div>
                        {/* <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th rowSpan={2} className="align-middle">BENEFITS AT A GLANCE</th>
                                        <th colSpan={9} className="colspan-head text-center">Primary
                                            <span className="border"></span>
                                        </th>
                                        <th colSpan={3} className="colspan-head text-center">Secondary
                                            <span className="border"></span>
                                        </th>
                                    </tr>
                                    <tr className="text-center">
                                        <th className="colspan-head" data-bs-toggle="tooltip" data-bs-placement="right" title={"'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block'"}>
                                            Covered<sup>1</sup>
                                        </th>
                                        <th className="colspan-head">Coinsurance %</th>
                                        <th className="colspan-head">PA Required</th>
                                        {coverage_summary?.qutenza_pharmacy.primary_pa_req === "Y" && (
                                            <>
                                                <th className="colspan-head">Effective Date </th>
                                                <th className="colspan-head">End Date</th>
                                            </>
                                        )}
                                        {
                                            ((coverage_summary && coverage_summary.denial_summary && coverage_summary.denial_summary.denial === "Y")) && (
                                                <>
                                                    <th className="colspan-head">Denial </th>
                                                    <th className="colspan-head">Denial Reason</th>
                                                </>
                                            )}
                                        {
                                            (coverage_summary && coverage_summary.denial_summary && coverage_summary.denial_summary.appeal === "Y") && (
                                                <>
                                                    <th className="colspan-head">Appeal Submitted Date </th>
                                                    <th className="colspan-head">Appeal Outcome </th>
                                                    {coverage_summary.denial_summary.appeal_outcome === "Denied" && <th className="colspan-head">Denial </th>}
                                                    {coverage_summary.denial_summary.appeal_outcome === "Denied" && <th className="colspan-head">Appeal Denial Reason</th>}
                                                </>
                                            )}
                                        <th className="colspan-head" data-bs-toggle="tooltip" data-bs-placement="right" title={"'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block'"}>
                                            Covered<sup>1</sup>
                                        </th>
                                        <th className="colspan-head">Coinsurance %</th>
                                        <th className="colspan-head">PA Required</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    <tr>
                                        {((Array.isArray(coverage_summary) && coverage_summary.length > 0) || Object.keys(coverage_summary || {}).length > 0) ? (
                                            <>
                                                <td>Pharmacy</td>
                                                <td>
                                                    {coverage_summary?.qutenza_pharmacy?.primary_covered}
                                                </td>
                                                <td>

                                                    {coverage_summary && Number(coverage_summary.qutenza_pharmacy.primary_coverage) > 0
                                                        ? `${Number(coverage_summary.qutenza_pharmacy.primary_coverage)}%`
                                                        : ""
                                                    }
                                                </td>
                                                <td>
                                                    {coverage_summary?.qutenza_pharmacy.primary_pa_req}
                                                </td>


                                                {coverage_summary?.qutenza_pharmacy.primary_pa_req === "Y" && (
                                                    <>
                                                        <td className="colspan-head">{coverage_summary?.qutenza_pharmacy.effective_date} </td>
                                                        <td className="colspan-head">{coverage_summary?.qutenza_pharmacy.end_date}</td>
                                                    </>
                                                )}
                                                {
                                                    (coverage_summary && coverage_summary.denial_summary && coverage_summary.denial_summary.denial === "Y") && (
                                                        <>
                                                            <td className="colspan-head">{coverage_summary.denial_summary.denial} </td>
                                                            <td className="colspan-head">{coverage_summary.denial_summary.denial_reason}</td>
                                                        </>
                                                    )}
                                                {
                                                    (coverage_summary && coverage_summary.denial_summary && coverage_summary.denial_summary.appeal === "Y") && (
                                                        <>
                                                            <td className="colspan-head">{coverage_summary.denial_summary.appeal_submitted_date} </td>
                                                            <td className="colspan-head">{coverage_summary.denial_summary.appeal_outcome}</td>
                                                            {coverage_summary.denial_summary.appeal_outcome === "Denied" && <td className="colspan-head">Y</td>}
                                                            {coverage_summary.denial_summary.appeal_outcome === "Denied" && <td className="colspan-head">{coverage_summary.denial_summary.appeal_denial_reason}</td>}
                                                        </>
                                                    )}

                                                <td>
                                                    {coverage_summary?.qutenza_pharmacy.secondary_covered}
                                                </td>
                                                <td>

                                                    {
                                                        coverage_summary &&
                                                            Number(coverage_summary.qutenza_pharmacy.secondary_coverage) > 0
                                                            ? `${Number(coverage_summary.qutenza_pharmacy.secondary_coverage)}%`
                                                            : ""
                                                    }
                                                </td>
                                                <td>
                                                    {coverage_summary?.qutenza_pharmacy.secondary_pa_req}
                                                </td>
                                            </>
                                        ) : <></>}
                                    </tr>

                                </tbody>
                            </table>
                        </div> */}
                        <div className="table-responsive">
                            <table className="table table-striped table-hover align-middle">
                                <thead>
                                    <tr>
                                        <th rowSpan={2} className="align-middle">
                                            BENEFITS AT A GLANCE
                                        </th>

                                        <th
                                            colSpan={primaryColumns}
                                            className="colspan-head text-center"
                                        >
                                            Primary
                                            <span className="border"></span>
                                        </th>

                                        <th
                                            colSpan={3}
                                            className="colspan-head text-center border-start border-end"
                                        >
                                            Secondary
                                            <span className="border"></span>
                                        </th>
                                    </tr>

                                    <tr className="text-center">
                                        {/* Primary */}
                                        <th
                                            className="colspan-head"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="right"
                                            title="'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block"
                                        >
                                            Covered<sup>1</sup>
                                        </th>

                                        <th className="colspan-head">Coinsurance %</th>
                                        <th className="colspan-head">PA Required</th>

                                        {showPaDates && (
                                            <>
                                                <th className="colspan-head">Effective Date</th>
                                                <th className="colspan-head">End Date</th>
                                            </>
                                        )}

                                        {showDenial && (
                                            <>
                                                <th className="colspan-head">Denial</th>
                                                <th className="colspan-head">Denial Reason</th>
                                            </>
                                        )}

                                        {showAppeal && (
                                            <>
                                                <th className="colspan-head">
                                                    Appeal Submitted Date
                                                </th>
                                                <th className="colspan-head">
                                                    Appeal Outcome
                                                </th>
                                            </>
                                        )}

                                        {showAppealDenial && (
                                            <>
                                                <th className="colspan-head">Denial</th>
                                                <th className="colspan-head">
                                                    Appeal Denial Reason
                                                </th>
                                            </>
                                        )}

                                        {/* Secondary: always last three columns */}
                                        <th
                                            className="colspan-head border-start"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="right"
                                            title="'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block"
                                        >
                                            Covered<sup>1</sup>
                                        </th>

                                        <th className="colspan-head">
                                            Coinsurance %
                                        </th>

                                        <th className="colspan-head border-end">
                                            PA Required
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className="text-center">
                                    {pharmacy ? (
                                        <tr>
                                            <td>Pharmacy</td>

                                            {/* Primary data */}
                                            <td>{pharmacy.primary_covered ?? ""}</td>

                                            <td>
                                                {Number(pharmacy.primary_coverage) > 0
                                                    ? `${Number(pharmacy.primary_coverage)}%`
                                                    : ""}
                                            </td>

                                            <td>{pharmacy.primary_pa_req ?? ""}</td>

                                            {showPaDates && (
                                                <>
                                                    <td>{pharmacy.effective_date ?? ""}</td>
                                                    <td>{pharmacy.end_date ?? ""}</td>
                                                </>
                                            )}

                                            {showDenial && (
                                                <>
                                                    <td>{denialSummary?.denial ?? ""}</td>
                                                    <td>
                                                        {denialSummary?.denial_reason ?? ""}
                                                    </td>
                                                </>
                                            )}

                                            {showAppeal && (
                                                <>
                                                    <td>
                                                        {denialSummary?.appeal_submitted_date ?? ""}
                                                    </td>
                                                    <td>
                                                        {denialSummary?.appeal_outcome ?? ""}
                                                    </td>
                                                </>
                                            )}

                                            {showAppealDenial && (
                                                <>
                                                    <td>Y</td>
                                                    <td>
                                                        {denialSummary?.appeal_denial_reason ?? ""}
                                                    </td>
                                                </>
                                            )}

                                            {/* Secondary data: always last three */}
                                            <td className="border-start">
                                                {pharmacy.secondary_covered ?? ""}
                                            </td>

                                            <td>
                                                {Number(pharmacy.secondary_coverage) > 0
                                                    ? `${Number(pharmacy.secondary_coverage)}%`
                                                    : ""}
                                            </td>

                                            <td className="border-end">
                                                {pharmacy.secondary_pa_req ?? ""}
                                            </td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan={1 + primaryColumns + 3}>
                                                No coverage information available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <p className="fs-6">
                                <sup>1</sup> <b>Note:</b> 'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block
                            </p>
                        </div>
                        {benefit_summary && benefit_summary.length > 0 && benefit_summary.map((item, index) => (
                            <div className="bg-mist p-4 rounded-3 mb-3" key={index}>
                                <h4 className="mb-3">{item.heading}</h4>
                                <div className="row mb-3">
                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-4">
                                                <span className="fw-semibold me-2">Insurance Name:</span>
                                            </div>
                                            <div className="col-8">
                                                <span className="fw-semibold me-2">{item.insurance_name}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-4">
                                                <span className="fw-semibold me-2">Insurance Type:</span>
                                            </div>
                                            <div className="col-8">
                                                <span className="fw-semibold me-2">{item.insurance_type}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>

                                    <div className="tab-content" id="networkContent98724">
                                        <div className="tab-pane show active" id="inNetworkTab" role="tabpanel" aria-labelledby="inNetworkTab">
                                            <div className="table-responsive">
                                                <table className="table table-striped table-hover">
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Product Coverage:</b></td>
                                                            <td>{item.product_coverage} %</td>
                                                            <td><b>Product Copay:</b></td>
                                                            <td>$ {item.product_copay}</td>

                                                            <td><b>Rx Max:</b></td>
                                                            <td>$ {item.rx_max}</td>
                                                            <td><b>Rx Max Met:</b></td>
                                                            <td>$ {item.rx_max_met}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Deductible:</b></td>
                                                            <td>$ {item.deductible}</td>
                                                            <td><b>Deductible Met:</b></td>
                                                            <td>$ {item.deductible_met}</td>

                                                            <td><b>OOP Max:</b></td>
                                                            <td>$ {item.oopmax}</td>
                                                            <td><b>OOP Max Met:</b></td>
                                                            <td>$ {item.oopmax_met}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Annual Max:</b></td>
                                                            <td>$ {item.annualmax}</td>
                                                            <td><b>Annual Max Met:</b></td>
                                                            <td>$ {item.annualmax_met}</td>

                                                            <td colSpan={4}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={12}><b>Rx Ben Notes:</b> {item.rx_ben_notes}</td>
                                                        </tr>
                                                        {/* <tr>
                                    <td>
                                        {drug_name?.includes('iovera') ?
                                            <b> C9809 Coinsurance:</b> : <b> J3304 Coinsurance:</b>
                                        }
                                    </td>
                                    <td>
                                        {item.coverage_J7336} %
                                    </td>
                                    <td>
                                        {drug_name?.includes('iovera') ?
                                            <b> C9809 Copay:</b> : <b> J3304 Coinsurance:</b>
                                        }
                                    </td>
                                    <td>$ {item.copay_J7336}</td>

                                    <td><b>Deductible:</b></td>
                                    <td>$ {item.deductible}</td>
                                    <td><b>Out of Packet Max:</b></td>
                                    <td>$ {item.out_of_packet_max}</td>
                                </tr>
                                <tr>
                                    <td><b>Admin Coinsurance:</b></td>
                                    <td>{item.admin_coverage} %</td>
                                    <td><b>Admin Copay:</b></td>
                                    <td>${item.admin_copay}</td>

                                    <td><b>Deductible Met:</b></td>
                                    <td>$ {item.deductible_met}</td>
                                    <td><b>Out of Pocket Met:</b></td>
                                    <td>$ {item.out_of_pocket_met}</td>
                                </tr>
                                <tr>
                                    <td><b>Office Coinsurance:</b></td>
                                    <td>{item.office_coverage} %</td>
                                    <td><b>Office Copay:</b></td>
                                    <td>$ {item.office_copay}</td>

                                    <td><b>Deductible Remaining:</b></td>
                                    <td>$ {item.deductible_remaining}</td>
                                    <td><b>Out of Pocket Remaining:</b></td>
                                    <td>$ {item.out_of_pocket_remaining}</td>
                                </tr>
                                <tr>
                                    <td colSpan={12}><b>Med Ben Notes:</b> {item.med_ben_notes}</td>
                                </tr> */}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* <div className="tab-pane show" id="outNetworkTab" role="tabpanel" aria-labelledby="outNetworkTab">
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                                    <td>
                                        {drug_name?.includes('iovera') ?
                                            <b> C9809 Coinsurance:</b> : <b> J3304 Coinsurance:</b>
                                        }
                                    </td>
                                    <td>
                                        {item.product_coverage} %
                                    </td>
                                    <td>
                                        {drug_name?.includes('iovera') ?
                                            <b> C9809 Copay</b> : <b> J3304 Coinsurance:</b>
                                        }
                                    </td>
                                    <td>$ {item.product_copay}</td>

                                    <td><b>Deductible:</b></td>
                                    <td>$ {item.deductible_2}</td>
                                    <td><b>Out of Packet Max:</b></td>
                                    <td>$ {item.out_of_packet_max_2}</td>
                                </tr>
                                <tr>
                                    <td><b>Admin Coinsurance:</b></td>
                                    <td>{item.admin_coverage_2} %</td>
                                    <td><b>Admin Copay:</b></td>
                                    <td>${item.admin_copay_2}</td>

                                    <td><b>Deductible Met:</b></td>
                                    <td>$ {item.deductible_met_2}</td>
                                    <td><b>Out of Pocket Met:</b></td>
                                    <td>$ {item.out_of_pocket_met_2}</td>
                                </tr>
                                <tr>
                                    <td><b>Office Coinsurance:</b></td>
                                    <td>{item.office_coverage_2} %</td>
                                    <td><b>Office Copay:</b></td>
                                    <td>$ {item.office_copay_2}</td>

                                    <td><b>Deductible Remaining:</b></td>
                                    <td>$ {item.deductible_remaining_2}</td>
                                    <td><b>Out of Pocket Remaining:</b></td>
                                    <td>$ {item.out_of_pocket_remaining_2}</td>
                                </tr>
                                <tr>
                                    <td colSpan={12}><b>Med Ben Notes:</b> {item.medical_benefit_notes}</td>
                                </tr>
                                 <tr>
                              <td><b>Product Coinsurance:</b></td>
                              <td>{item.product_coverage} %</td>
                              <td><b>Product Copay:</b></td>
                              <td>$ {item.product_copay}</td>
                            </tr>
                            <tr>
                              <td><b>Admin Coinsurance:</b></td>
                              <td>{item.admin_coverage_2} %</td>
                              <td><b>Admin copay:</b></td>
                              <td>$ {item.admin_copay_2}</td>
                            </tr>
                            <tr>
                              <td><b>Office Coinsurance:</b></td>
                              <td>{item.office_coverage_2} %</td>
                              <td><b>Office Copay:</b></td>
                              <td>$ {item.office_copay}</td>
                            </tr>
                            <tr>
                              <td><b>Deductible Met:</b></td>
                              <td>$ {item.deductible_met_2}</td>
                              <td><b>Deductible:</b></td>
                              <td>$ {item.deductible_2}</td>
                            </tr>
                            <tr>
                              <td><b>Out of Pocket Met:</b></td>
                              <td>$ {item.out_of_pocket_met_2}</td>
                              <td><b>Deductible:</b></td>
                              <td>$ {item.out_of_packet_max_2}</td>
                            </tr>
                            <tr>
                              <td colSpan={12}><b>Med Ben Notes:</b> {item.medical_benefit_notes}</td>
                            </tr> 
                          </tbody>
                        </table>
                      </div>
                    </div> */}

                                        {/* <div>
                      <h4>{index === 0 ? 'PRIMARY' : 'SECONDARY'} PHARMACY BENEFITS (SPECIALTY PHARMACY OPTION)</h4>
                      <b>Rx Benefit Notes:</b>
                      {item.rx_bene_notes}
                    </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className="alert alert-warning py-2 m-0">
                        Benefits are still pending for this case.
                    </div>
                }
            </div>
        </div>
    );
};

export default DetailPageInfo;
